import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { UserPermissionRequest } from '../../requests/platform/user-permission.request';
import { UserPermissionResponse, ListUserPermissionResponse } from '../../responses/platform/user-permission.response';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({ providedIn: 'root' })
export class UserPermissionService extends CommonService {
  private base = environment.urlApiPlatform + 'UserPermission/';

  constructor(private http: HttpClient) {
    super();
  }

  /** Upsert (cria/edita) permissões do usuário */
  public upsert(request: UserPermissionRequest): Observable<ReturnStruct> {
    return this.http
      .post<ReturnStruct>(this.base, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Busca permissões por idUser. includeInactive=true para trazer todas. */
  public getByUser(idUser: number, includeInactive: boolean = false): Observable<UserPermissionResponse> {
    const url = `${this.base}idUser/${idUser}?includeInactive=${includeInactive}`;
    return this.http
      .get<UserPermissionResponse>(url, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Lista agrupada por usuário (somente ativas, conforme repo) */
  public list(): Observable<ListUserPermissionResponse> {
    return this.http
      .get<ListUserPermissionResponse>(this.base + 'list', this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Exclui logicamente TODAS as permissões do usuário */
  public deleteByUser(idUser: number): Observable<ReturnStruct> {
    return this.http
      .delete<ReturnStruct>(this.base + 'idUser/' + idUser, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
